/**
 * Return the width of the viewport.
 */
const getViewportWidth = () => {
  // We want the width that doesn't include the scrollbar as our first choice
  return document.documentElement ? document.documentElement.clientWidth : window.innerWidth;
};

export default getViewportWidth;